import parsePhoneNumber from './parsePhoneNumber'

// Form field keys that carry phone numbers. redux-form does not run a
// field's `parse` on initial values, so API values with a country-code
// prefix must be normalized here — otherwise the 10-digit input mask keeps
// the prefix and truncates the trailing digits.
//
// Keep in sync with the phone columns in the types.js key maps
// (CONTACT_KEY_MAP, BUSINESS_INFORMATION_KEYMAP, PROGRAM_APPLICATION_KEYMAP).
// A form that maps a phone column to a different form key won't be normalized
// unless that key is added here.
const PHONE_FORM_KEYS = ['phone', 'mobilePhone']

const normalizePhoneNumbers = (values) => {
  if (!values) return values

  const normalized = { ...values }
  PHONE_FORM_KEYS.forEach((key) => {
    if (normalized[key]) normalized[key] = parsePhoneNumber(normalized[key])
  })

  return normalized
}

export default normalizePhoneNumbers
